import { render, staticRenderFns } from "./public-layout.vue?vue&type=template&id=16e06b8e&scoped=true&"
import script from "./public-layout.ts?vue&type=script&lang=ts&"
export * from "./public-layout.ts?vue&type=script&lang=ts&"
import style0 from "./public-layout.scss?vue&type=style&index=0&id=16e06b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e06b8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
